module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        Kapcsolat\n        "), _c('span', [_vm._v("Vegye fel velünk a kapcsolatot")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "ordered-list with-icon"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Cím:")]), _vm._v(" Győr, Egyetem tér 1.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Telefon:")]), _vm._v(" +36 96 555 666")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope"
  }), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Email:")]), _vm._v(" info@sze.hu")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Adatvédelmi felelős:")]), _vm._v(" Nagy Viktor (nv@sze.hu)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64921594"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/contact.vue
// module id = 382
// module chunks = 0